import clsx from 'clsx';

export interface SpinnerProps {
  className?: string;
}

export function Spinner({ className }: SpinnerProps): JSX.Element {
  return (
    <svg
      viewBox="0 0 38 38"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      fillRule="evenodd"
      clipRule="evenodd"
      className={clsx('animate-loading-spinner', className)}
    >
      <path
        d="M32.2583 32.2582C33.2346 31.2819 33.2346 29.699 32.2583 28.7227L26.955 23.4194C25.9786 22.4431 24.3957 22.4431 23.4194 23.4194C22.4431 24.3957 22.4431 25.9786 23.4194 26.9549L28.7227 32.2582C29.699 33.2346 31.2819 33.2346 32.2583 32.2582Z"
        fill="currentColor"
      />
      <path
        d="M35.25 16.5C36.6307 16.5 37.75 17.6193 37.75 19C37.75 20.3807 36.6307 21.5 35.25 21.5H27.75C26.3693 21.5 25.25 20.3807 25.25 19C25.25 17.6193 26.3693 16.5 27.75 16.5H35.25Z"
        fill="currentColor"
        style={{ opacity: 0.87 }}
      />
      <path
        d="M32.2582 5.74175C31.2819 4.76544 29.699 4.76544 28.7227 5.74175L23.4194 11.0451C22.4431 12.0214 22.4431 13.6043 23.4194 14.5806C24.3957 15.5569 25.9786 15.5569 26.9549 14.5806L32.2582 9.27728C33.2346 8.30097 33.2346 6.71806 32.2582 5.74175Z"
        fill="currentColor"
        style={{ opacity: 0.74 }}
      />
      <path
        d="M19 0.25C17.6193 0.25 16.5 1.36929 16.5 2.75V10.25C16.5 11.6307 17.6193 12.75 19 12.75C20.3807 12.75 21.5 11.6307 21.5 10.25V2.75C21.5 1.36929 20.3807 0.25 19 0.25Z"
        fill="currentColor"
        style={{ opacity: 0.61 }}
      />
      <path
        d="M14.5806 14.5806C15.5569 13.6042 15.5569 12.0213 14.5806 11.045L9.2773 5.74172C8.30099 4.76541 6.71808 4.76541 5.74176 5.74172C4.76545 6.71803 4.76545 8.30094 5.74176 9.27726L11.0451 14.5806C12.0214 15.5569 13.6043 15.5569 14.5806 14.5806Z"
        fill="currentColor"
        style={{ opacity: 0.48 }}
      />
      <path
        d="M10.25 16.5C11.6307 16.5 12.75 17.6193 12.75 19C12.75 20.3807 11.6307 21.5 10.25 21.5H2.75C1.36929 21.5 0.25 20.3807 0.25 19C0.25 17.6193 1.36929 16.5 2.75 16.5H10.25Z"
        fill="currentColor"
        style={{ opacity: 0.35 }}
      />
      <path
        d="M14.5806 23.4194C13.6043 22.4431 12.0214 22.4431 11.0451 23.4194L5.74176 28.7227C4.76545 29.6991 4.76545 31.282 5.74176 32.2583C6.71807 33.2346 8.30098 33.2346 9.27729 32.2583L14.5806 26.955C15.5569 25.9787 15.5569 24.3958 14.5806 23.4194Z"
        fill="currentColor"
        style={{ opacity: 0.22 }}
      />
      <path
        d="M16.5 27.75C16.5 26.3693 17.6193 25.25 19 25.25C20.3807 25.25 21.5 26.3693 21.5 27.75V35.25C21.5 36.6307 20.3807 37.75 19 37.75C17.6193 37.75 16.5 36.6307 16.5 35.25V27.75Z"
        fill="currentColor"
        style={{ opacity: 0.1 }}
      />
    </svg>
  );
}
